import type { OfferType, RankType } from '@smg-real-estate/hg-rets-schema';
import type { ListingCompletenessScore } from '@smg-real-estate/hg-search-libs';

export type RankingExplainerRangeFilter =
  | { from: number; to?: number }
  | { from?: number; to: number };

export enum SupportedPlatforms {
  HOMEGATE = 'homegate',
  IMMOSCOUT24 = 'immoscout24',
}

export interface RankingExplainerSnapshotPayload {
  listingId: string;
  offerType: OfferType;
  categories: string[];
  geoTags: string[];
  platform: string;
  radius: number;
  priceFilter?: RankingExplainerRangeFilter;
  roomsFilter?: RankingExplainerRangeFilter;
}

export const RANKING_EXPLAINER_DEFAULT_PLATFORM = SupportedPlatforms.IMMOSCOUT24;
/** Default comparable-search radius in meters. */
export const RANKING_EXPLAINER_DEFAULT_RADIUS_IN_M = 3000; // 3km

export const RANKING_EXPLAINER_PLATFORM_LABELS: Record<SupportedPlatforms, string> = {
  [SupportedPlatforms.HOMEGATE]: 'Homegate',
  [SupportedPlatforms.IMMOSCOUT24]: 'ImmoScout24',
};

export interface RankingExplainerRankingScoreDetails {
  listingId: string;
  listingCompletenessScore: ListingCompletenessScore;
  rankType: RankType;
  rankingScore: number;
}

export interface RankingExplainerListingSnapshot {
  /** Package identifier returned by the ranking-explainer API, including legacy packages. */
  package: string;
  pageNumber: number;
  pageSize: number;
  position: number;
  rankingScore: RankingExplainerRankingScoreDetails;
}

export interface RankingExplainerCompetition {
  listings: RankingExplainerRankingScoreDetails[];
  averageCompletionScore: number;
  numberOfGoldPackages: number;
  numberOfPromotedPremium: number;
  numberOfPromotedTop: number;
  numberOfPromotedTotal: number;
  numberOfSilverPackages: number;
  numberOfBronzePackages: number;
  numberOfOtherPackages: number;
}

export interface RankingExplainerSnapshotResponse {
  listing: RankingExplainerListingSnapshot;
  competition: RankingExplainerCompetition;
  totalResults: number;
}
